const typeList = [
  // {
  //   type: 'ORIGIN',
  //   label: 'Keterangan lokasi asal'
  // },
  // {
  //   type: 'DESTINATION',
  //   label: 'Keterangan lokasi tujuan'
  // },
  {
    type: 'COST',
    label: 'Pilihan biaya tambahan'
  },
  {
    type: 'CANCELLATION',
    label: 'Alasan pembatalan'
  },
  {
    type: 'ACCIDENT',
    label: 'Kecelakaan'
  },
]
const getTypeLabel = function (type) {
  console.log('TCL: getTypeLabel -> type', type)
  return typeList.find(i => i.type === type).label || ''
}

export default {
  selectionInfoDatabase: 'Database Pilihan dan Alasan',
  searchText: 'Cari Pilihan dan Alasan',
  item: 'Item',
  type: 'Tipe',
  edit: 'Ubah Entri Pilihan dan Alasan',
  create: 'Buat Entri Pilihan dan Alasan',
  selectionText: 'Teks Pilihan',
  selectionType: 'Keterangan untuk: ',
  needConfirmmation: 'Butuh konfirmasi',
  typeList,
  getTypeLabel
}
